<template>
	<footer>
		<p class="contact-tag">
			<a href="mailto:hello@lucasmccallum.com">hello@lucasmccallum.com</a>
		</p>
	</footer>
</template>

<script>
export default {};
</script>

<style lang="scss"></style>
